// extracted by mini-css-extract-plugin
module.exports = {"givePriority":"styles_givePriority__30xTY","comparisonSelect":"styles_comparisonSelect__fMPNa","input":"styles_input__wLl6A"};